import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../Pages/Newhomepage.css'
import banphone from '../Pages/Newimages/banner-phone.png'
import sidephone from '../Pages/Newimages/sidephone.png'

// import flip from '../Pages/Newimages/flipkart.png'
import aws from '../Pages/Newimages/aws.png'
import zoho from '../Pages/Newimages/zoho.png'
// import amazon from '../Pages/Newimages/amazon.png'
import surya from '../Pages/Newimages/surya.png'
import csb from '../Pages/Newimages/csb.png'
import digital from '../Pages/Newimages/digital.png'
import axis from '../Pages/Newimages/axis.png'
import open from '../Pages/Newimages/open.png'



import stat from '../Pages/Newimages/stat.png'
import time from '../Pages/Newimages/time.png'
import circle from '../Pages/Newimages/circle.png'
import thunder from '../Pages/Newimages/thunder.png'
import empowering from '../Pages/Newimages/empowering.png'

import lap from '../Pages/Newimages/laptop.png'

import playbtn from '../Pages/Newimages/playbtn.png'
import applebtn from '../Pages/Newimages/applebtn.png'
import newplaystore from '../Pages/Newimages/newplaystore.png'
import Newnavbar from '../Pages/Newnavbar'
import Newfooter from './Newfooter';






const NewHomepage = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });
    }, []);
    return (<>
            <Newnavbar/>
        <div className="new_ui_all">
            
            <div className="banner_img py-5 px-[16px]">
                <div className="flex flex-wrap max-w-7xl mx-auto ">
                    <div className="md:w-8/12 w-12/12">
                        <div className="new_ban_des">
                            <h2>Effortless Financial Management with <span className="ban_span" >PayNeft</span> </h2>
                            <p>Manage your business finances effortlessly with our smart expense management suite. Simplify approvals, track real-time expenses, and access insightful reports all in one secure platform designed for Indian businesses to thrive.</p>
                            <a href="https://business.payneft.in/payneft/pay/register" target="_blank" rel="noopener noreferrer">
                            <button type="button">Get Started <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                <path d="M11.666 19.8334L17.4993 14L11.666 8.16669" stroke="white" stroke-width="2.33377" stroke-linecap="round" stroke-linejoin="round" />
                            </svg></button>
                            </a>
                        </div>
                    </div>
                    <div className="md:!w-4/12 w-12/12 flex jutify-center">
                        <img src={banphone} alt="Banner Phone" className="img-fluid"   data-aos="zoom-in-up"     />

                    </div>

                </div>
            </div>
             <div className="trust_companies !mx-auto !px-4 !py-8">
                <h2 className="text-[14px] !leading-relaxed">
                    Recognized by Prestigious Institutions Worldwide 
                </h2>
                {/* Desktop View */}
                <div className="!hidden md:!flex !space-x-6 !mx-auto !w-fit">
                    {[zoho, aws, axis, digital, csb, open, surya, open].map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt="Partner Logo"
                            className="!w-[100px] !h-[100px] !object-contain"
                        />
                    ))}
                </div>
                {/* Mobile/Tablet Carousel */}
                <div className="!block md:!hidden !overflow-hidden !relative !w-full">
                    <div className="!flex !w-max !animate-scroll-left !space-x-6">
                        {[...Array(2)].flatMap(() =>
                            [zoho, aws, axis, digital, csb, open, surya, open].map((src, i) => (
                                <img
                                    key={`${src}-${i}`}
                                    src={src}
                                    alt="Partner Logo"
                                    className="!w-[100px] !h-[100px] !object-contain"
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>

        <section className='px-[16px] md:space-y-[80px] space-y-[40px] bg-[#fff1f6]'>

            <div className="trust_below_des py-[40px]">
                <div className="max-w-7xl mx-auto flex md:flex-row flex-col md:!space-y-[0px] !space-y-[24px] justify-around">
                    <div className="">
                        <p>
                            ARE YOU STILL CONFUSED <br />
                            ABOUT YOUR PAYMENTS AND <br />
                            EXPENSES?
                        </p>
                    </div>
                    <div className="">
                        <h2>
                            Smart Expense Management, <br />
                            Payment Solutions for All   <br />
                            Type of Business.


                        </h2>
                    </div>
                </div>
            </div>


            <div className="iphone md-py-5 py-0">
                <div className="max-w-7xl  mx-auto flex flex-wrap">
                    <div className="md:w-3/12 w-12/12 !mx-auto">
                        <img src={sidephone} alt="Edge" className="!mx-auto" data-aos="zoom-in-up"  />
                    </div>
                    <div className="md:w-8/12 w-12/12">
                        <div className="iphone-des container md-mt-0 mt-3">
                            <div className="i-card">
                                <div className="num">
                                    <span>1</span>
                                </div>
                                <div className="i-card-des">
                                    <h2>Handle High - Volume Transactions with Ease</h2>
                                    <p>
                                        Efficiently manage large-scale transactions without any hassle. Our solution ensures speed, accuracy, and reliability for seamless operations.
                                    </p>
                                </div>
                                <div className="info">
                                    {/* <IoIosInformationCircleOutline /> */}
                                    {/* <img src={frame} alt="Edge" className="img-fluid" /> */}

                                </div>
                            </div>
                            <div className="i-card">
                                <div className="num">
                                    <span>2</span>
                                </div>
                                <div className="i-card-des">
                                    <h2>Advanced Security - Protecting data and payments</h2>
                                    <p>
                                        Ensure the safety of your data and transactions with cutting-edge security measures. Our advanced protection safeguards your business against threats.
                                    </p>
                                </div>
                                <div className="info">
                                    {/* <img src={frame} alt="Edge" className="img-fluid" /> */}
                                </div>
                            </div>
                            <div className="i-card">
                                <div className="num">
                                    <span>3</span>
                                </div>
                                <div className="i-card-des">
                                    <h2>Expand your business worldwide</h2>
                                    <p>
                                        Take your business global with seamless scalability and reach. Unlock new markets and connect with customers across the world effortlessly
                                    </p>
                                </div>
                                <div className="info">
                                    {/* <img src={frame} alt="Edge" className="img-fluid" /> */}
                                </div>
                            </div>
                            <div className="i-card">
                                <div className="num">
                                    <span>4</span>
                                </div>
                                <div className="i-card-des">
                                    <h2>Customizable Integration - Tailored to your business needs</h2>
                                    <p>
                                        Adapt solutions to match your unique business requirements. Our customizable integrations ensure a perfect fit for your operations.
                                    </p>
                                </div>
                                <div className="info">
                                    {/* <img src={frame} alt="Edge" className="img-fluid" /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="half-iphone py-5">
                <div className="max-w-7xl  mx-auto flex md:flex-row flex-col !justify-between gap-x-[20px]">
                    <div className="md:!w-7/12 !w-12/12 md:order-1 order-2">
                        <div className="half-i-des">
                            <h2>
                                Empowering Your Business with <br /> Tailored Solutions
                            </h2>
                            <div className="transactions">
                                <div className="transaction-col">
                                    <img src={time} alt="Edge" className="img-fluid" />
                                    <h3>Real-Time Expense Tracking </h3>
                                    <p>
                                    Enjoy seamless, secure, and reliable payments  trusted by <br /> businesses for  fast transactions anywhere.
                                    </p>
                                </div>
                                <div className="transaction-col">
                                    <img src={thunder} alt="Edge" className="img-fluid" />
                                    <h3>Fast & Seamless Payments</h3>
                                    <p>
                                    Experience seamless, secure payments anytime,<br /> anywhere, with trusted speed and reliability in every transaction.
                                    </p>
                                </div>
                            </div>
                            <div className="transactions py-3">
                                <div className="transaction-col">
                                    <img src={circle} alt="Edge" className="img-fluid" />
                                    <h3>Categorized Expenses</h3>
                                    <p>
                                    Effortlessly track and categorize your <br /> spending with PayNeft for smarter financial decisions.
                                    </p>
                                </div>
                                <div className="transaction-col">
                                    {/* Uncomment and ensure FaHandHoldingHeart is imported */}
                                    {/* <FaHandHoldingHeart className="globe-h" /> */}
                                    <img src={stat} alt="Edge" className="img-fluid" />
                                    <h3>Detailed Spending Reports</h3>
                                    <p>
                                    Gain detailed spending insights with PayNeft’s <br /> reports to track trends, set goals, and identify savings.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="md:!w-5/12 !w-12/12 md:order-2 order-1">
                        <img src={empowering} alt="Edge" className="img-fluid" data-aos="zoom-in-up"  />

                    </div>
                </div>
            </div>

        </section>


            <div className="lap-sec px-[16px]">
          <h1>
          Stay Ahead with PayNeft on Our <br /> Web or Mobile App
                    </h1>
          <div className="lap-img container mx-auto">
            <img src={lap} alt="Edge" className="img-fluid w-[70%]" data-aos="zoom-in-up"  />
          </div>
          <div className="peoples pb-5 mb-5">
            <div className="max-w-6xl mx-auto grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 ">
              <div className="">
                <div className="peoples-des">
                  <h3>32k</h3>
                  <h2>More than 32k people use PayNeft</h2>
                  <p>
                  More than 32k people have used our services, many have used PayNeft
                  </p>
                </div>
              </div>
              <div className="">
                <div className="peoples-des">
                  <h3>5k</h3>
                  <h2>5k people Use the app</h2>
                  <p>
                  more than 5K people download the app and try it. You have to try
                  </p>
                </div>
              </div>
              <div className="">
                <div className="peoples-des">
                  <h3>10k+</h3>
                  <h2>10k+ people helped</h2>
                  <p>
                  10k+ people have been helped by Edge's services, we are ready to help you
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:py-[180px] py-[60px]">
            <div className=" bg-[#262626] max-w-7xl mx-auto flex md:flex-row flex-col justify-between rounded-[40px] md:h-[300px] md:relative">
           

              <div className="soon-all ">
                <p>
                Stay Ahead with PayNeft's <br /> Latest Upgrade
                                </p>
                <div className="flex">
                    <div>
                        <img src={playbtn} alt="Edge" className="img-fluid p-3" />
                    </div>
                    <div>
                        <img src={applebtn} alt="Edge" className="img-fluid p-3" />
                    </div>
                </div>
              </div>
               <div className="md:absolute relative bottom-0 md:right-20 md:justify-end justify-center flex">
                    <img src={newplaystore}  alt="Edge" className=" md:w-[30%] w-[100%]" data-aos="zoom-in-up"  />
                </div>
               
               
            </div>
          </div>
        </div>

<Newfooter/>

        </div>
    </>
    )
}

export default NewHomepage
